export class AbCryptRequestModel {
  public data: string;

  constructor(data: string) {
    this.data = data;
  }
}
